<template>
    <field-wrapper
        id="customerIdentification"
        class="field-CustomerIdentification"
        :label-text="texts.label"
        :error-text="errorMessage"
        :show-error="Boolean(errorMessage)"
    >
        <selector-customer-identification :error="errorMessage" />
    </field-wrapper>
</template>

<script>
import { mapGetters } from "vuex";
import FieldWrapper from "@/components/elements/FieldWrapper";
import SelectorCustomerIdentification from "@/components/selectors/SelectorCustomerIdentification";

export default {
    components: {
        FieldWrapper,
        SelectorCustomerIdentification
    },
    props: {
        validate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        texts() {
            return this.$t("field_customer_identification");
        },
        errorMessage() {
            if (this.validate && this.error) return this.texts[this.error];
            return null;
        },
        ...mapGetters({
            error: "customer/getIdentificationTypeError"
        })
    }
};
</script>
